// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3eUTO","fileDisabled":"File_fileDisabled__12-gJ"};